import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { App, LoadingController, ModalController, NavController, Platform } from 'ionic-angular';
import { SessionProvider } from '../../../../../providers/session/session';
import { ValueProvider } from '../../../../../providers/value/value';
import { MysportUserProfilePage } from '../../../../me/mysport/mysport-user-profile/mysport-user-profile';
import { TeamSettingsModal } from '../../../../team-settings-modal/team-settings-modal';
import { TournamentService, PlanEnum } from '../../services/tournament.service';
import { NewTouMainPage } from '../new-tou/new-tou-main';
import { ResultGroupKoPage } from '../results/result-group-ko/result-group-ko';
import { GamerResultKoPage } from '../results/result-ko/result-ko';
import { ResultMeKoPage } from '../results/result-me-ko/result-me-ko';
import { GamerResultOnePage } from '../results/result-one/result-one';
import { ResultPreRoundKoPage } from '../results/result-pre-round-ko/result-pre-round-ko';
import { ResultPreRoundPage } from '../results/result-pre-round/result-pre-round';
import { ResultTwoGKoPlPage } from '../results/result-twog-ko-pl/result-twog-ko-pl';

@Component({
  selector: 'tou-list-page',
  templateUrl: 'tou-list.html'
})
export class TouListPage{
  reloader: boolean = true;
  planList;

  constructor(
    private app: App,
    public gs: TournamentService,
    private sessionService: SessionProvider,
    private loadingCtrl: LoadingController,
    private translate: TranslateService,
    private valueService: ValueProvider,
    private platform: Platform,
    private modalCtrl:ModalController
    ) { }

  ionViewWillEnter(){
    let loader = this.loadingCtrl.create({});
    loader.present();
    this.gs.getPlanList().then(t => {
      this.planList = t;
      loader.dismiss();
      this.reload();
    }).catch(e => {
      loader.dismiss();
    });
  }

  reload(){
    this.reloader = false;
    setTimeout(() => {
      this.reloader = true;
    });
  }

  init(){
    let loader = this.loadingCtrl.create({});
    loader.present();
    this.gs.getPlanList().then(res => {
      this.planList = res;
      loader.dismiss();
    });
  }

  onRemoveTou(id: number){
    this.gs.removeTouById(id).then((res) => {
      console.log(res);
      if(!this.gs.planList.length){
        this.gs.$planListChangeSub.next(1);
      }
    });
  }

  onPlusButton() {
    this.sessionService.getTokenAndNavigate().then(token => {
      const modal = this.modalCtrl.create(NewTouMainPage);
      modal.onDidDismiss(option => {
        console.log('option',option)
      })
      modal.present();
    })
  }

  onOpenSettings(){
    this.sessionService.getTokenAndNavigate().then(token => {
      const modal = this.modalCtrl.create(TeamSettingsModal);
      modal.onDidDismiss(option => {
        console.log('option',option)
      })
      modal.present();
    });
  }

  onClick(plan, index){
    let page = null;
    switch (plan.plantype) {
      case PlanEnum.PlanOnePage: page = GamerResultOnePage; break;
      case PlanEnum.KoPage: page = GamerResultKoPage; break;
      case PlanEnum.VorPage: page = ResultPreRoundPage; break;
      case PlanEnum.VorKoPage: page = ResultPreRoundKoPage; break;
      case PlanEnum.GruKoPage: page = ResultGroupKoPage; break;
      case PlanEnum.GruKoPlPage: page = ResultTwoGKoPlPage; break;
      case PlanEnum.MePage: page = ResultMeKoPage; break;
    };
    if(page){
      (this.app.getRootNav() as NavController).push(page, { plan: plan, activePlan: index });
      // const modal = this.modalCtrl.create(page, {plan: plan, activePlan: index });
      //   modal.onDidDismiss(option => {
      //     console.log('option',option)
      //   })
      //   modal.present();
    }
  }

  showLogin(){
    let loader = this.loadingCtrl.create({
      content: this.translate.instant('GLOBAL_LOADING')
    });
    loader.present();

    this.valueService.getProfileBackgrounds().then(backgrounds => {
      (this.app.getRootNav() as NavController)
        .push(MysportUserProfilePage, {
          data: { profile: this.sessionService.profile, backgrounds: backgrounds }
        })
        .then(() => loader.dismiss());
    });
  }

  public isLoged(): boolean {
    return this.sessionService.isLoged;
  }

  public profileImage(): string {
    return this.sessionService.profile.profilePicLink || 'assets/imgs/default-image-32@1x.png';
  }

  public get type(): String{
    return "";
  }
}






// WEBPACK FOOTER //
// /src/pages/apps/gamer/pages/tou-list/tou-list.ts